import React, { useState } from 'react'
import Google from './google'
import Facebook from './facebook'
import FacebookAuthorizers from './facebook-authorizers'
import Connect from 'app/redux/connect'
import Redux from 'app/interface/redux'
import Basic from 'app/redux/actions/pages/business/basic'

interface SocialProps extends Redux {
  new: boolean
}

const Social = (props: SocialProps) => {
  const { main } = props.pages.business

  const [facebookBuilderOn, setFacebookBuilderOn] = useState<boolean>(main.fb_builder)

  const switchMode = async () => {
    const builderOn = !facebookBuilderOn
    setFacebookBuilderOn(builderOn)
    Basic.update('fb_builder', builderOn)
  }

  return (
    <div>
      {facebookBuilderOn ? (
        <Facebook switchMode={switchMode} new={props.new} />
      ) : (
        <FacebookAuthorizers switchMode={switchMode} />
      )}
      <Google />
    </div>
  )
}

export default Connect(Social)
